import React from "react";
import img from "../images/company2.jpg";
import {Link} from "react-router-dom";

const AboutUs = () => {
    return (
        <>
            <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id="about">
                <section
                    className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                        <img alt="M&rivet - o firme" className="rounded-t float-right" src={img}/>
                    </div>
                    <div
                        className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >
                        <h1 className="text-3xl  text-brand font-bold">O nás</h1>
                        <div>
                            <p className="my-3 text-xl text-black">
                                Naša firma M&rivet, s.r.o. nie je ako ostatné veľké spoločnosti. Sme menšia firma a aj
                                napriek tomu
                                dokážeme konkurovať veľkým spoločnostiam, dokážeme byť flexibilný, rýchly a samozrejme
                                100% spoľahliví. Máme dlhoročnú prax, sme na trhu už 25 rokov.
                            </p>
                            <p className="my-3 text-xl text-black">
                                Naše hlavné sústredenie
                                je v strojárskom priemysle, stavebnom a zbrojárskom priemysle. Vďaka našim skúsenostiam
                                a dopytu zákazníka sme rozšírili svoje pôsobenie na rezanie a delenie materiálu vodným
                                lúčom .
                            </p>
                        </div>


                        <Link
                            to="/contact"
                            className="text-white bg-brand hover:bg-brand-600 inline-flex items-center justify-center w-full px-6 py-2 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0 group"
                        >
                            Kontaktujte nás
                            <svg
                                className="w-4 h-4 ml-1 group-hover: translate-x-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </Link>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AboutUs;
